const lang = navigator.language.substring(0, 2)
const langProp = {
  lang: lang,
  direction: lang === 'ar' ? 'rtl' : 'ltr'
}
console.log('lang=' + langProp.direction)
export default langProp
